import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';

import { ApiService } from './../api.service';
import { CacheService } from './../../utils/cache.service';
import { map, share, tap } from 'rxjs/operators';

export abstract class Resource {
    protected cacheable = true;
    protected idField = 'id';

    protected pathCreate = this.path;

    private items$: BehaviorSubject<Object[]>;

    protected pathDetail: (number) => string = (id) => `${this.path}/${id}`;
    protected pathDelete: (number) => string = (id) => this.pathDetail(id);

    get items(): Observable<Object[]> {
        return this.items$.asObservable().pipe(
            tap((items) => {
                if (this.cacheable) {
                    if (items) {
                        this.cache.set(this.path, items, this.sensible);
                    } else {
                        this.cache.delete(this.path);
                    }
                }
            }),
            share()
        );
    }

    item(id: number): Observable<Object> {
        return this.items.pipe(map((items) => items.find((u) => u[this.idField] === id)));
    }

    constructor(
        protected cache: CacheService,
        protected api: ApiService,
        protected path: string,
        protected sensible = false
    ) {
        this.items$ = new BehaviorSubject([]);

        if (this.cacheable) {
            const items = this.cache.get(this.path);
            this.items$.next(JSON.parse(items));
        }
    }

    list(search: Object = {}): Observable<Object[]> {
        return this.api.get(this.path, search).pipe(tap((items) => this.items$.next(items)));
    }

    detail(id: number): Observable<Object> {
        return this.api.get(this.pathDetail(id)).pipe(
            tap((retrievedItem) => {
                const list = this.items$.getValue() || [];
                const index = list.findIndex((u) => u[this.idField] === retrievedItem[this.idField]);

                if (index > -1) {
                    Object.assign(list[index], retrievedItem);
                } else {
                    list.push(retrievedItem);
                }

                this.items$.next(list);
            })
        );
    }
    delete(id: number): Observable<Object> {
        return this.api
            .delete(this.pathDelete(id))
            .pipe(tap(() => this.items$.next(this.items$.getValue().filter((u) => u[this.idField] !== id))));
    }
    create(obj: Object) {
        return this.api
            .post(this.pathCreate, obj)
            .pipe(tap((item) => this.items$.next([item, ...this.items$.getValue()])));
    }
    clear() {
        this.items$.next(null);
    }
}
